import { ActionIcon, LoadingOverlay, Paper, Text, Tooltip } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import dayjs from 'dayjs';
import moment from 'moment';
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Calendar, Views, dayjsLocalizer } from 'react-big-calendar';
import { useNavigate } from "react-router-dom";
import { GET_ALL_JOBS, GET_ALL_TASKS_DESTINATIONS } from "../services/jobs";
import { extenseWeekday, getExtenseDatetime, getMedia, groupBy } from "../utility/util";
dayjs.locale('pt-br')

const localizer = dayjsLocalizer(dayjs)

function Event({ event }) {
    return <div style={{ display: 'flex', flexDirection: 'row', whiteSpace: 'nowrap', alignItems: 'center' }}>
        {(event.medias ?? []).map(({ Icon, color, key }) => {
            const published = (event.destinations ?? []).some(d => d.origin === key && (d?.publications ?? []).some(p => !p.error));
            return <Tooltip label={published ? "Publicado" : "Agendado"}>
                <ActionIcon mr="3px" size="sm" color={published ? "green" : color} variant={published ? "filled" : "outline"}><Icon /></ActionIcon>
            </Tooltip>
        })}
        <Text c="black" fw="bold" size="xs">{event.title}</Text>
    </div>
}

export const JobsCalendar = ({ customerId = null, agentId = null }) => {
    const [tasks, setTasks] = useState([]);
    const [view, setView] = useState('month');
    const [date, setDate] = useState(new Date());
    const [loadingJobs, setLoadingJobs] = useState(false);
    const navigate = useNavigate();

    const period = useMemo(
        () => {
            let start, end;
            switch (view) {
                case 'month':
                    start = moment(date).startOf("month").subtract(5, "days").toDate();
                    end = moment(date).endOf("month").add(5, "days").toDate();
                    break;
                case 'week':
                    start = moment(date).startOf("week"); // Monday star.toDate()t
                    end = moment(date).endOf("week").toDate();
                    break;
                case 'day':
                    start = moment(date).startOf("day").toDate();
                    end = moment(date).endOf("day").toDate();
                    break;
                default:
                    start = moment(date).startOf("month").toDate();
                    end = moment(date).endOf("month").toDate();
            }
            return [start, end];
        },
        [date, view]
    );

    const filters = useMemo(() => ({
        dateStart: period[0],
        dateEnd: period[1],
        customerId,
        agentId
    }), [period, customerId, agentId])

    const loadTasks = async () => {
        setLoadingJobs(true);
        const items = await GET_ALL_TASKS_DESTINATIONS({ ...filters })
        setTasks(items);
        setLoadingJobs(false);
    };

    const { messages, formats, components, defaultDate } = useMemo(
        () => ({
            components: {
                // agenda: {
                //     event: Event,
                // },
                month: { event: Event },
                event: Event,
            },
            defaultDate: moment().toDate(),
            formats: {
                dayHeaderFormat: (date) => getExtenseDatetime(date, false),
                timeGutterFormat: (date) => moment(date).format("HH:mm"),
                dayFormat: (date) => moment(date).format("DD"),
                weekdayFormat: (date) => extenseWeekday(moment(date).weekday()),
                eventTimeRangeFormat: () => "",
            },
            messages: {
                date: 'Data',
                time: 'Hora',
                event: 'Job',
                allDay: 'Dia Todo',
                week: 'Semana',
                work_week: 'Dia Útil',
                day: 'Dia',
                month: 'Mês',
                previous: 'Anterior',
                next: 'Próximo',
                yesterday: 'Ontem',
                tomorrow: 'Amanhã',
                today: 'Hoje',
                agenda: 'Agenda',

                noEventsInRange: 'Nenhum conteúdo no período selecionado.',
                showMore: (total, remainingEvents, events) => `+${total} jobs`,
            },
        }),
        []
    );

    const eventPropGetter = useCallback(
        (event, start, end, isSelected) => ({
            style: {
                background: '#F4F4F4',
                border: '1px solid #CACACA',
                color: '#8a8a8a',
                padding: '2px',
                minHeight: 25,

                // eventPropGetter={(event) => ({
                //     style: {
                // minHeight: '30px',
                // whiteSpace: 'normal', // wrap text
                //     },
                // })}
            }
        }),
        []
    )

    const events = useMemo(() => {
        console.log({ tasks });
        return tasks.reduce((pv, task) => {
            const gTasks: any[] = (task.destinations ?? []).map(destination => ({ destination, task })).filter(t => t.destination.publish_date)
            const grouped = groupBy(gTasks, t => moment(t.destination.publish_date).format("YYYY-MM-DD HH"));
            console.log({ grouped })

            const items = grouped
                .map(g => {
                    const medias = groupBy(g[1], t => t.destination.origin).filter(g => g).map(g => getMedia(g[0]));
                    const date = moment(`${g[0]}:00:00`).startOf("hour").toDate();
                    return {
                        jobId: g[1][0].task.jobId,
                        taskId: g[1][0].task.taskId,
                        medias,
                        destinations: g[1].map(t => t.destination),
                        title: g[1][0].task.title,
                        start: date,
                        end: date,
                    }
                });
            console.log({ items })

            return pv.concat(items);
        }, []);
    }, [tasks]);

    useEffect(() => { loadTasks() }, [filters])

    return <Paper p="md" shadow="xs">
        <LoadingOverlay visible={loadingJobs} />
        <Calendar
            components={components}
            localizer={localizer}
            events={events}
            startAccessor="start"
            endAccessor="end"
            eventPropGetter={eventPropGetter}
            dateCellWrapper={{ style: { display: 'none' } }}
            formats={formats}
            messages={messages}
            defaultDate={defaultDate}
            defaultView={Views.MONTH}
            onSelectEvent={(item) => { navigate(`/jobs/${item.jobId}?item=${item.taskId}`) }}
            style={{ height: '85vh' }}
            onView={setView}
            onNavigate={setDate}
        />
    </Paper>
}